export default function Features() {
  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold text-gray-900 mb-6">
            Why <span className="text-cyan-500">Choose</span> Our <span className="text-cyan-500">VPN</span>
          </h2>
          <p className="text-xl text-gray-600">
            Experience the ultimate protection with cutting-edge technology
          </p>
        </div>

        <div className="flex gap-8">
          <div className="w-[45%] h-[600px] rounded-3xl bg-gradient-to-br from-blue-900 to-purple-900 relative overflow-hidden group hover:shadow-2xl transition-all cursor-pointer">
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="ri-lock-password-line text-white/20 text-[200px]"></i>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-10 bg-gradient-to-t from-black/80 to-transparent">
              <h3 className="text-3xl font-bold text-white mb-4">Military-Grade Encryption</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                AES-256 encryption ensures your data remains completely secure and private, protecting you from hackers and surveillance.
              </p>
            </div>
          </div>

          <div className="flex-1 flex flex-col gap-8">
            <div className="h-[280px] rounded-3xl bg-emerald-50 relative overflow-hidden group hover:shadow-2xl transition-all cursor-pointer">
              <div className="absolute inset-0 flex items-center justify-center">
                <i className="ri-shield-check-line text-emerald-500/30 text-[160px]"></i>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-emerald-900/80 to-transparent">
                <h3 className="text-2xl font-bold text-white mb-3">No-Log Policy</h3>
                <p className="text-white/90 text-base leading-relaxed">
                  We never track, collect, or store your browsing activity. Your privacy is guaranteed.
                </p>
              </div>
            </div>

            <div className="h-[288px] rounded-3xl bg-rose-50 relative overflow-hidden group hover:shadow-2xl transition-all cursor-pointer">
              <div className="absolute inset-0 flex items-center justify-center">
                <i className="ri-speed-line text-rose-500/30 text-[160px]"></i>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-rose-900/80 to-transparent">
                <h3 className="text-2xl font-bold text-white mb-3">Lightning Fast Speeds</h3>
                <p className="text-white/90 text-base leading-relaxed">
                  Optimized servers worldwide ensure you get the fastest connection without compromising security.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}